export const IFRAME_DATA_MESSAGE = 'IFRAME_DATA_MESSAGE' as const

export const CANVAS_HOOKS = {
  ON_CANVAS_UPDATE: 'on_canvas_update',
  ON_SECTION_LIST_UPDATE: 'on_section_list_update',
} as const

export const IFRAME_ACTION_TYPES = {
  SET_DATA: 'set_data',
  UPDATE_DATA: 'update_data',
  RESIZE_IFRAME: 'resize_iframe',
  IFRAME_LOADED: 'iframe_loaded',
  SECTION_LIST_UPDATED: 'section_list_updated',
  CANVAS_UPDATED: 'canvas_updated',
  NAVIGATE_NEXT_PAGE: 'navigate_next_page',
  NAVIGATE_PREVIOUS_PAGE: 'navigate_previous_page',
  NAVIGATE_PAGE: 'navigate_page',
} as const

export type IFrameMessage<Payload = any> = {
  id: string
  type: typeof IFRAME_DATA_MESSAGE
  body: {
    action: (typeof IFRAME_ACTION_TYPES)[keyof typeof IFRAME_ACTION_TYPES]
    data: Payload
  }
}
